// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rewardIcon[data-v-52dbc3f2] {\n  margin-right: 5px;\n}", "",{"version":3,"sources":["webpack://./src/components/elements/Reward.vue","webpack://./Reward.vue"],"names":[],"mappings":"AACA;EACC,iBAAA;ACAD","sourcesContent":["\n.rewardIcon {\n\tmargin-right: 5px;\n}\n",".rewardIcon {\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
